import { FunctionComponent } from 'react'
import OnboardingTourModal from '@/components/tour/onboarding-tour-modal'
import { reduxAPI } from '@/store/redux-api'

const GlobalOnboardingTourModal: FunctionComponent = () => {
  const modal = reduxAPI.state.modal.hooks.useVisible('onboardingModal')

  const handleClose = modal.toggleVisible

  return <OnboardingTourModal open={modal.visible} onClose={handleClose} />
}

export default GlobalOnboardingTourModal
